module.exports = __webpack_public_path__ + "img/small_bg320201216.34c46e80.png";